import VariousMaterielDto from './VariousMaterielDto'

export default class VariousMaterielAssignatedDto extends VariousMaterielDto {
    constructor(obj) {
        super(obj)
        this.siteCode = obj.siteCode
        this.situationDate = obj.situationDate
    }
}
